import { __ } from '@wordpress/i18n';
import { useContext } from 'preact/hooks';

import { AppContext } from '../context/AppContext';
import CountryFilter from './filters/CountryFilter';
import RegionFilter from './filters/RegionFilter';
import ProgramFilter from './filters/ProgramFilter';
import LegacyProgramFilter from './filters/LegacyProgramFilter';
import SelectedPrograms from './filters/SelectedPrograms';
import { CountryPost, Region, ProgramTerm } from '../../../types';

type FiltersProps = {
	wpCountryPosts: CountryPost[];
	wpRegionTerms: Region[];
	wpProgramTerms: ProgramTerm[];
}

export default function Filters( { wpCountryPosts, wpRegionTerms, wpProgramTerms }: FiltersProps ) {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext; // eslint-disable-line no-unused-vars

	return (
		<>
			<form
				className="tcc-map__filter-form"
				onSubmit={ ( event ) => {
					event.preventDefault();
				} }
			>
				<fieldset className="tcc-map__filters">
					<legend className="caption-text">{ __( 'Filter By', 'tcc-map' ) }</legend>

					<CountryFilter
						wpCountryPosts={ wpCountryPosts }
					/>

					<RegionFilter
						wpRegionTerms={ wpRegionTerms }
					/>

					<ProgramFilter
						wpProgramTerms={ wpProgramTerms }
					/>

					<LegacyProgramFilter
						wpProgramTerms={ wpProgramTerms }
					/>

					<SelectedPrograms />

				</fieldset>

				<button
					className="tcc-map__filter-submit"
					type="button"
					onClick={ () => {
						dispatch( { type: 'RESET' } );
					} }
				>
					{ __( 'Clear Filters', 'tcc-map' ) }
				</button>
			</form>
		</>
	);
}
